import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';



export default function PlaceDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [place, setPlace] = useState(null);



    if (!place) {
        return (
            <div className="flex items-center justify-center flex-grow py-20">
                <p className="text-gray-600">Yükleniyor…</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen">


            <main className="flex-grow px-4 py-8 max-w-3xl mx-auto">
                {/* Başlık */}
                <h1 className="text-3xl font-bold mb-6">{place.title}</h1>

                {/* Fotoğraf */}
                <img
                    src={place.image}
                    alt={place.title}
                    className="w-full h-80 object-cover rounded-lg mb-6 shadow-md"
                />

                {/* Konum ve Açıklama */}
                <p className="text-gray-600 mb-2">
                    <strong>Konum:</strong> {place.location}
                </p>
                <p className="text-gray-700 mb-8">{place.description}</p>

                {/* Butonlar */}
                <div className="flex space-x-4">
                    <button
                        onClick={() => navigate('/')}
                        className="px-6 py-2 border border-blue-500 text-blue-500 rounded-lg
                       hover:bg-blue-50 transition"
                    >
                        Ana Menüye Dön
                    </button>

                    <button
                        onClick={() => navigate(`/reservation/${place.id}`)}
                        className="px-6 py-2 bg-gradient-to-r from-blue-500 to-purple-500
                       text-white rounded-lg shadow-lg transform transition
                       hover:scale-105 hover:from-blue-600 hover:to-purple-600
                       focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                        Rezervasyon Yap
                    </button>
                </div>
            </main>


        </div>
    );
}